import AppActionCreators from './AppActionCreators';
import _ from 'lodash';
	
export default _.assign({}, AppActionCreators);